<template>
  <div class="notice">
    <div class="notice_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">公告</div>
    </div>
    <div class="notice_bottom">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div
          class="notice_bottom_list"
          v-for="(item, index) in noticeLists"
          :key="index"
          :style="{ color: item.isRead === true ? '#999999' : '#333333' }"
          @click="getNotice(item.id)"
        >
          <template>
            <p v-html="item.title"></p>
            <div>
              <span>{{ item.createTime }}</span>
            </div>
          </template>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "notice",
  data() {
    return {
      noticeLists: [],
      loading: false,
      pageNo: 0,
      pageSize: 20,
      finished: false,
      error: false,
    };
  },
  created() {
    this.NoticeList();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    onLoad() {
      this.pageNo += 1;
      this.NoticeList();
    },
    async NoticeList() {
      let res = await this.$apis.myServe.syslist({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      console.log(res);
      if (res.resultCode == 200) {
        this.finished = res.data.list.length < 20;
        this.noticeLists.push(...res.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    getNotice(item) {
      this.$router.push({ path: "/noticeDetails", query: { id: item } });
    },
  },
};
</script>

<style lang="scss" scoped>
.notice {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  .notice_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 72px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }
  .notice_bottom {
    width: 100%;
    height: 100%;
    margin-top: 13px;
    .notice_bottom_list {
      width: 94%;
      height: 83px;
      background: #fff;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      margin-left: 12px;
      overflow: hidden;
      margin-top: 5px;
      p {
        font-size: 16px;
        font-family: PingFangSC-Heavy, PingFang SC;
        font-weight: 800;
        margin-left: 20px;
        margin-top: 21px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div {
        margin-top: 7px;
        span {
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>